import React from 'react';
import { Users2Icon, TrendingUpIcon, BarChart3Icon } from 'lucide-react';
import { useLanguage } from './LanguageProvider';
import { useTranslation } from 'react-i18next';
export function SyndicateExample() {
  const {
    formatCurrency
  } = useLanguage();
  const {
    t
  } = useTranslation();
  return <div className="mt-16 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl p-8 shadow-lg" data-id="element-907">
      <div className="text-center mb-8" data-id="element-908">
        <h3 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-909">
          {t('syndicateAuctions.example.title', 'Example')}:{' '}
          <span className="text-blue-600 dark:text-brand-green" data-id="element-910">
            {t('syndicateAuctions.example.subtitle', 'Syndicate Auction')}
          </span>
        </h3>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-911">
        <div className="space-y-6" data-id="element-912">
          <div data-id="element-913">
            <h4 className="text-lg font-semibold text-gray-900 dark:text-white flex items-center gap-2" data-id="element-914">
              <BarChart3Icon className="h-5 w-5 text-blue-600 dark:text-brand-green" data-id="element-915" />
              B-Stock Auction: 200 Samsung Galaxy Phones
            </h4>
            <div className="mt-4 space-y-3" data-id="element-916">
              {[{
              label: t('syndicateAuctions.example.retailValue', 'Retail Value (MSRP)'),
              value: formatCurrency(60000)
            }, {
              label: t('syndicateAuctions.example.condition', 'Condition'),
              value: 'Grade B & C Mixed'
            }, {
              label: t('syndicateAuctions.example.syndicateBid', 'Syndicate Bid'),
              value: formatCurrency(20000),
              highlight: true
            }, {
              label: t('syndicateAuctions.example.perDevice', 'Per Device Cost'),
              value: `${formatCurrency(100)} (vs. ${formatCurrency(150)}+ individually)`
            }].map((item, index) => <div key={index} className="flex justify-between items-center py-2 border-b border-gray-200 dark:border-gray-800" data-id="element-917">
                  <span className="text-gray-600 dark:text-gray-400" data-id="element-918">
                    {item.label}
                  </span>
                  <span className={item.highlight ? 'text-blue-600 dark:text-brand-green font-semibold' : 'text-gray-900 dark:text-white'} data-id="element-919">
                    {item.value}
                  </span>
                </div>)}
            </div>
          </div>
          <div data-id="element-920">
            <h4 className="text-lg font-semibold text-gray-900 dark:text-white flex items-center gap-2 mb-4" data-id="element-921">
              <Users2Icon className="h-5 w-5 text-blue-600 dark:text-brand-green" data-id="element-922" />
              {t('syndicateAuctions.example.members', 'Syndicate Members')} (4)
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-923">
              {[1, 2, 3, 4].map(member => <div key={member} className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4" data-id="element-924">
                  <div className="font-medium text-gray-900 dark:text-white" data-id="element-925">
                    {t('syndicateAuctions.example.member', 'Member')} {member}
                  </div>
                  <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-926">
                    {formatCurrency(5000)}{' '}
                    {t('syndicateAuctions.example.contribution', 'contribution')}
                  </div>
                </div>)}
            </div>
          </div>
        </div>
        <div className="space-y-6" data-id="element-927">
          <div data-id="element-928">
            <h4 className="text-lg font-semibold text-gray-900 dark:text-white flex items-center gap-2" data-id="element-929">
              <TrendingUpIcon className="h-5 w-5 text-blue-600 dark:text-brand-green" data-id="element-930" />
              {t('syndicateAuctions.example.outcomeBenefits', 'Outcome & Benefits')}
            </h4>
            <div className="mt-4 space-y-3" data-id="element-931">
              {[t('syndicateAuctions.example.benefit1', 'Each member receives 50 devices (evenly distributed across conditions)'), t('syndicateAuctions.example.benefit2', 'Lower per-unit cost enables higher profit margins'), t('syndicateAuctions.example.benefit3', 'Shared shipping costs reduce expenses further'), t('syndicateAuctions.example.benefit4', 'Risk is distributed among all members'), t('syndicateAuctions.example.benefit5', 'Members can specialize in different sales channels')].map((benefit, index) => <div key={index} className="flex items-start gap-2" data-id="element-932">
                  <div className="h-5 w-5 rounded-full bg-blue-100 dark:bg-brand-green/10 flex items-center justify-center flex-shrink-0" data-id="element-933">
                    <div className="h-2 w-2 rounded-full bg-blue-600 dark:bg-brand-green" data-id="element-934" />
                  </div>
                  <span className="text-gray-700 dark:text-gray-300" data-id="element-935">
                    {benefit}
                  </span>
                </div>)}
            </div>
          </div>
          <div className="bg-blue-50 dark:bg-brand-green/5 rounded-lg p-6" data-id="element-936">
            <div className="flex justify-between items-center mb-2" data-id="element-937">
              <span className="text-gray-700 dark:text-gray-300" data-id="element-938">
                {t('syndicateAuctions.example.potentialROI', 'Potential ROI')}
              </span>
              <span className="text-2xl font-bold text-blue-600 dark:text-brand-green" data-id="element-939">
                35-50%
              </span>
            </div>
            <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2" data-id="element-940">
              <div className="bg-blue-600 dark:bg-brand-green h-2 rounded-full" style={{
              width: '42%'
            }} data-id="element-941" />
            </div>
          </div>
        </div>
      </div>
    </div>;
}